import { ethers } from "ethers";

// LINK
export const link = "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4"; // arb

// UNI
export const uni = "0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0"; // arb

// USDT
export const usdt = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"; // arb

// MIM
export const mim = "0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A"; // arb

// FRAX
export const frax = "0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F"; // arb

// DAI
export const dai = "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1"; // arb

// WETH
export const weth = "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"; // arb

// USDC
export const usdc = "0xaf88d065e77c8cC2239327C5EDb3A432268e5831"; // arb

// USDC.e
export const usdc_e = "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8"; // arb

// WBTC
export const wbtc = "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f"; // arb

// BTC (for compatibility with old code)
export const btc = "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f";

//--------------------DO NOT CHANGE------------------------//
// Arbitrumm

// GMX Vault
export const vaultAddress = "0x489ee077994B6658eAfA855C308275EAd8097C4A";

// GMX Router 
export const routerAddress = "0xaBBc5F99639c9B6bCb58544ddf04EFA6802F4064";
// GMX Reader
export const readerAddress = "0x22199a49A999c351eF7927602CFB187ec3cae489";

// network
export const network = "Arbitrum";
// chainId
export const networkChainId = 42161;
// RPC url
export const providerUrl = "https://arb1.arbitrum.io/rpc";
// Provider
export const provider = new ethers.providers.JsonRpcProvider(providerUrl);

export const publicWebsockets = [
  "wss://arbitrum-one-rpc.publicnode.com",
  "wss://arbitrum.drpc.org",
  "wss://arbitrum.gateway.tenderly.co",
  "wss://arbitrum.callstaticrpc.com",
  "wss://arbitrum-one-rpc.publicnode.com",
  "wss://arb1.arbitrum.io/feed",
].filter(Boolean);

export const alchemyRPC = "https://arb-mainnet.g.alchemy.com/v2/lPYGW-Ld-owAfdma4-Nt8cTwHNnLqVY8"
export const websockets = [
    { url: process.env.REACT_APP_INFURA_WS, name: "Infura" },
    { url: process.env.REACT_APP_INFURA_WS2, name: "Infura (Backup)" },
    { url: process.env.REACT_APP_ALCHEMY_WS, name: "Alchemy" },
    { url: process.env.REACT_APP_ALCHEMY_WS2, name: "Alchemy (Backup)" },
    { url: process.env.REACT_APP_CHAINSTACK_WS, name: "Chainstack" },
    { url: process.env.REACT_APP_CHAINSTACK_WS2, name: "Chainstack (Backup)" },
    { url: process.env.REACT_APP_LAVA_WS, name: "Lava" },
    { url: process.env.REACT_APP_QUICKNODE_WS, name: "QuickNode" },
    { url: process.env.REACT_APP_QUICKNODE_WS2, name: "QuickNode (Backup)" },
    { url: process.env.REACT_APP_GETBLOCK_WS, name: "GetBlock" },
    { url: process.env.REACT_APP_GETBLOCK_WS2, name: "GetBlock (Backup)" },
    { url: process.env.REACT_APP_BLASTAPI_WS, name: "BlastAPI" },
    { url: process.env.REACT_APP_BLASTAPI_WS2, name: "BlastAPI (Backup)" },
  ].filter(ws => ws.url); // Remove entries where the URL is not defined
 
  export const defaultWebsockets = [
   // { url: process.env.REACT_APP_INFURA_WS, name: "Infura" },
    { url: process.env.REACT_APP_INFURA_WS2, name: "Infura (Backup)" },
   // { url: process.env.REACT_APP_ALCHEMY_WS, name: "Alchemy" },
    { url: process.env.REACT_APP_ALCHEMY_WS2, name: "Alchemy (Backup)" },
    //{ url: process.env.REACT_APP_CHAINSTACK_WS, name: "Chainstack" },
    //{ url: process.env.REACT_APP_CHAINSTACK_WS2, name: "Chainstack (Backup)" },
    "wss://arbitrum-one-rpc.publicnode.com",
    "wss://arbitrum.drpc.org",
    "wss://arbitrum.gateway.tenderly.co",
    "wss://arbitrum-one-rpc.publicnode.com",
  //  { url: process.env.REACT_APP_QUICKNODE_WS, name: "QuickNode" },
  //  { url: process.env.REACT_APP_QUICKNODE_WS2, name: "QuickNode (Backup)" },
  
  ].filter(ws => ws.url); // Remove entries where the URL is not defined
 